<template>
  <!-- TO BE IMPLEMENTED LATER -->
  <section>
    <span>Document Cabinet</span>
  </section>
</template>

<script>
  export default {
    name: "DocCabinet"
  }
</script>
